import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function ClientBrief() {
  return (
    <section className="client__brief p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={10} className="m-auto text-center">
            <h2 style={{ color: "#000" }}>
              Client <span style={{ color: "#75CB4C" }}>Brief</span>
            </h2>
            <p>
              Dream Energy Solutions is an energy broker and consulting firm,
              working diligently to assist businesses in Ontario, Canada to make
              better energy supply decisions and pocket savings.
            </p>
            <h2 style={{ color: "#717783" }}>Mission</h2>
            <div className="mission_boxes">
              <div className="mission_box">
                YEAR - <span style={{ color: "#75CB4C" }}> 2019</span>
              </div>
              <div className="mission_box">
                ROLE - <span style={{ color: "#75CB4C" }}> UI/UX DESIGN</span>
              </div>
              <div className="mission_box">
                TYPE -
                <span style={{ color: "#75CB4C" }}> WEBSITE DEVELOPMENT</span>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default ClientBrief;
